module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "CO1"
  }, [_vm._v("The document, which came to be known as the Dead List, first appeared on December 12, on Web sites hosted by servers in London, New York, Hong Kong, and Johannesburg, paid for with untraceable debit cards registered to false names. Some indications exist that the orders may have originated in Jakarta, but little else of consequence can be determined:")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Head-exth"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("TO THE PEOPLE OF THE WORLD:")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-No-Indent-ext1"
  }, [_vm._v("For too long you have ignored the teachings of the one true God. He has tired of your ignorance and blasphemy. And as has occurred thrice before, there shall be a mighty Reaping.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("So that you might have time to repent your sins, the Reaping will occur in stages, slowly at first, then more rapidly, a righteous tsunami carrying all corruption before it. Only the Elite will be spared, to continue life in a sterilized world.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("In accordance with prophesy, it will happen in this fashion: on December 13, our high holy day, one sinner will die. On the second day, two will perish. Then four, then eight, and then sixteen, doubling every day until the world is cleansed.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("Some of these first men and women will be known to the world. Most will not. As all have sinned, none but the Elite will be spared. It is too late to join us. If you are Elite, you know already who you are.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("So that the world may know and tremble, the first to die are published below. Some of these names were extracted from the excellent list “The One Hundred Worst Unindicted Criminals,” published in the July edition of the American "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rolling Stone")]), _vm._v(" magazine. Others are upon a list to follow. And others, for reasons that will be known in due time, are secrets known only to the Elite.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("The wicked will be punished. It is so that all may understand and tremble at the terrible justice to come that the despoilers upon this list will be numbered among the first.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("One the first day. Two the second. Four the third. Then eight, sixteen, thirty-two, and so on. Until our Christmas gift to the world, delivered on December 25—Freedom. You will enjoy the end of days without domination by governments or false religions. On that day, among other sinners, the following will die:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "List-Unnum-ul-first"
  }, [_vm._v("The bishop of Rome")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul"
  }, [_vm._v("The prime minister of England")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul"
  }, [_vm._v("The prime minister of Israel")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul"
  }, [_vm._v("The president of the Executive Yuan of the People’s Republic of China")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul"
  }, [_vm._v("The chairman of the Federal Reserve")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-last"
  }, [_vm._v("The president of the United States")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("All other world leaders will follow in turn. All mortal men and women, save the Elite, will follow. There is nothing any of you can do to prevent this. No medications, countermeasures, or fortresses can protect you. There is nothing any of you can do to save yourselves, or change the inevitable. This warning is only given so that those who are capable might save their souls with prayer.")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "Extract-Source-exts"
  }, [_vm._v("Merry Christmas")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd72356","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/opener.vue
// module id = 72
// module chunks = 0